<div class="financeiro-page">
  <div class="header d-flex justify-content-between align-items-center flex-wrap gap-2">
    <div>
      <h1>Importar retorno CNAB — Santander</h1>
      <p class="text-muted small mb-0">
        Envie o arquivo <strong>.RET</strong> baixado no Internet Banking para atualizar confirmações de boleto, liquidações e rejeições.
      </p>
    </div>
    <a routerLink="/gerar-cnab" class="btn btn-outline-secondary btn-sm">Voltar ao Gerar CNAB</a>
  </div>

  <div class="card-box mb-3">
    <h2 class="h6 mb-3">Arquivo de retorno</h2>
    <div class="d-flex flex-wrap align-items-end gap-3">
      <div style="min-width: 220px">
        <label class="form-label small mb-1">Selecionar arquivo</label>
        <input type="file" class="form-control form-control-sm" accept=".ret,.RET,.txt" (change)="onArquivoRetornoChange($event)" />
      </div>
      <button type="button" class="btn btn-primary btn-sm" [disabled]="processandoRetorno || !arquivoRetorno" (click)="enviarRetorno()">
        <i class="fa fa-upload"></i> Processar retorno
      </button>
    </div>
  </div>

  <p class="text-muted small mb-0">
    A configuração da conta está em <a routerLink="/configuracao-cnab-santander">Configuração CNAB Santander</a>.
  </p>
</div>
